export default {"src":"/_next/static/media/portfolio-icon.a4acf36f.svg","height":20,"width":20};